<div class="flex flex-col items-center rounded-[9px] p-[10px] bg-[#F0F3F3] mx-4 mb-5">
  <mat-icon class="!w-[17px] !h-[15px] mb-1" [svgIcon]="'wallet'"></mat-icon>
  <p class="leading-[1.4] text-[12px] !mb-0 text-[#567474] text-center"
     [innerHTML]="'Share invite to AMLofficer with Partners & Colleges. <br> Become part of Referal Program.'"></p>
</div>

<div class="bg-[#F0F3F3] px-4 pb-5">
  @if (report(); as report) {
    @if (report.data.registeredAddressRiskResponse; as riskResponse) {
      @if (report.data.senderWallets; as receiverWallets) {
        @if (receiverWallets.length > 0) {
          <cdk-accordion class="mb-5">
            <cdk-accordion-item #accordionItem="cdkAccordionItem">
              <div class="flex justify-between items-center w-full py-1 mb-2">
                <span class="text-[10px] font-bold uppercase min-w-fit max-w-fit w-full mr-1">
                  @if (receiverWallets.length === 1) {
                    TOP-{{ receiverWallets.length }} wallet by volume of incoming funds
                  } @else if (receiverWallets.length > 1 && receiverWallets.length < 5) {
                    TOP-{{ receiverWallets.length }} wallets by volume of incoming funds
                  } @else {
                    TOP-{{ receiverWallets.length }} wallets by volume of incoming funds
                  }
                </span>
                <span class="h-[1px] w-full bg-[#022D35]"></span>
                <button class="min-w-[24px]" (click)="accordionItem.toggle()">
                  <mat-icon class="text-[#45525B]" [class.rotate-180]="!accordionItem.expanded">keyboard_arrow_down
                  </mat-icon>
                </button>
              </div>

              @if (!accordionItem.expanded) {
                <p class="flex justify-between text-[12px] leading-[1.2] text-[#94A3A6] !mb-2 pl-5">
                  <span>Wallet Risk Score / Trading Volume</span>
                  <span>AML Status</span>
                </p>
                @for (wallet of receiverWallets; track $index) {
                  <div class="flex items-start mb-2">
                    <span class="min-w-5 text-[#45525B] pt-[9px]">
                      {{ $index + 1 }}.
                    </span>
                    <div class="w-full rounded-[7px] py-[6px] px-[9px] border border-solid border-[#3C6B8314]"
                         [ngClass]="{
                        'bg-[#022D35]': wallet.risk === 'SEVERE',
                        'bg-white': wallet.risk !== 'SEVERE'
                        }">
                      <div class="flex justify-between pb-[5px] border-b border-solid border-opacity-5"
                           [ngClass]="{
                          'border-white': wallet.risk === 'SEVERE',
                          'border-black': wallet.risk !== 'SEVERE'
                        }">
                        <app-report-status [risk]="wallet.risk"></app-report-status>
                        <span class="flex items-center cursor-pointer" [appCopyToClipboardCopied]="wallet.address">
                          <mat-icon
                            [ngClass]="{
                              'text-white': wallet.risk === 'SEVERE',
                              'text-[#022D35]': wallet.risk !== 'SEVERE'
                            }" class="!w-[13px] !h-[12px] mr-1" [svgIcon]="'wallet'"></mat-icon>
                          <span
                            [ngClass]="{
                              'text-white': wallet.risk === 'SEVERE',
                              'text-[#022D35]': wallet.risk !== 'SEVERE'
                            }" class="text-[#45525B]">{{ wallet.address | cropWithDotsCenter }}</span>
                          <app-copy-button
                            [currentColor]="wallet.risk === 'SEVERE' ? 'text-white' : 'text-fraud-gray-500'"
                            class="ml-1" [value]="wallet.address" [size]="'medium'"></app-copy-button>
                        </span>
                      </div>
                      <div class="flex justify-between items-center pt-1">
                        <span
                          [ngClass]="{
                          'text-white bg-[#FFFFFF33]': wallet.risk === 'SEVERE',
                          'text-[#45525B] bg-[#23454233]': wallet.risk !== 'SEVERE'
                        }"
                          class="text-[11px] font-medium rounded-[60px] bg-[#23454233] px-1 py-[2px]">{{ wallet.amount | cutNumber:('1.2-2') }}
                          USDT</span>
                        @if (wallet.walletProtected) {
                          <span class="flex items-center py-[3px] px-[7px] bg-[#F2F4F5] rounded-[29px]">
                            <span class="bg-[#50AF95] rounded-full mr-1 w-[10px] h-[10px]"></span>
                            <span class="text-[#567474]">Wallet protected</span>
                          </span>
                        } @else {
                          <button (click)="createReferral(wallet.address)" type="button" mat-raised-button mat-button
                                  color="primary"
                                  class="flex items-center justify-center text-[12px] font-medium pt-[2px] pb-[3px] text-[#C93535] border border-solid border-[#C93535] rounded-[4px] px-2">
                            Share AML Invite
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                }
              }
            </cdk-accordion-item>
          </cdk-accordion>
        }
      }

      @if (report.data.receiverWallets; as senderWallets) {
        @if (senderWallets.length > 0) {
          <cdk-accordion>
            <cdk-accordion-item #accordionItem="cdkAccordionItem">
              <div class="flex justify-between items-center w-full py-1 mb-2">
                <span class="text-[10px] font-bold uppercase min-w-fit max-w-fit w-full mr-1">
                  @if (senderWallets.length === 1) {
                    TOP-{{ senderWallets.length }} wallet by volume of Outgoing funds
                  } @else if (senderWallets.length > 1 && senderWallets.length < 5) {
                    TOP-{{ senderWallets.length }} wallets by volume of Outgoing funds
                  } @else {
                    TOP-{{ senderWallets.length }} wallets by volume of Outgoing funds
                  }
                </span>
                <span class="h-[1px] w-full bg-[#022D35]"></span>
                <button class="min-w-[24px]" (click)="accordionItem.toggle()">
                  <mat-icon class="text-[#45525B]" [class.rotate-180]="!accordionItem.expanded">keyboard_arrow_down
                  </mat-icon>
                </button>
              </div>

              @if (!accordionItem.expanded) {
                <p class="flex justify-between text-[12px] leading-[1.2] text-[#94A3A6] !mb-2 pl-5">
                  <span>Wallet Risk Score / Trading Volume</span>
                  <span>AML Status</span>
                </p>
                @for (wallet of senderWallets; track $index) {
                  <div class="flex items-start mb-2">
                    <span class="min-w-5 text-[#45525B] pt-[9px]">
                      {{ $index + 1 }}.
                    </span>
                    <div class="w-full rounded-[7px] py-[6px] px-[9px] border border-solid border-[#3C6B8314]"
                         [ngClass]="{
                      'bg-[#022D35]': wallet.risk === 'SEVERE',
                      'bg-white': wallet.risk !== 'SEVERE'
                    }">
                      <div class="flex justify-between pb-[5px] border-b border-solid border-opacity-5"
                           [ngClass]="{
                        'border-white': wallet.risk === 'SEVERE',
                        'border-black': wallet.risk !== 'SEVERE'
                      }">
                        <app-report-status [risk]="wallet.risk"></app-report-status>
                        <span class="flex items-center cursor-pointer" [appCopyToClipboardCopied]="wallet.address">
                          <mat-icon
                            [ngClass]="{
                            'text-white': wallet.risk === 'SEVERE',
                            'text-[#022D35]': wallet.risk !== 'SEVERE'
                          }" class="!w-[13px] !h-[12px] mr-1" [svgIcon]="'wallet'"></mat-icon>
                          <span
                            [ngClass]="{
                            'text-white': wallet.risk === 'SEVERE',
                            'text-[#022D35]': wallet.risk !== 'SEVERE'
                          }" class="text-[#45525B]">{{ wallet.address | cropWithDotsCenter }}</span>
                          <app-copy-button
                            [currentColor]="wallet.risk === 'SEVERE' ? 'text-white' : 'text-fraud-gray-500'"
                            class="ml-1" [value]="wallet.address" [size]="'medium'"></app-copy-button>
                        </span>
                      </div>
                      <div class="flex justify-between items-center pt-1">
                        <span
                          [ngClass]="{
                          'text-white bg-[#FFFFFF33]': wallet.risk === 'SEVERE',
                          'text-[#45525B] bg-[#23454233]': wallet.risk !== 'SEVERE'
                        }"
                          class="text-[11px] font-medium rounded-[60px] bg-[#23454233] px-1 py-[2px]">{{ wallet.amount | cutNumber:('1.2-2') }}
                          USDT</span>
                        @if (wallet.walletProtected) {
                          <span class="flex items-center py-[3px] px-[7px] bg-[#F2F4F5] rounded-[29px]">
                            <span class="bg-[#50AF95] rounded-full mr-1 w-[10px] h-[10px]"></span>
                            <span class="text-[#567474]">Wallet protected</span>
                          </span>
                        } @else {
                          <button (click)="createReferral(wallet.address)" type="button" mat-raised-button mat-button
                                  color="primary"
                                  class="flex items-center justify-center text-[12px] font-medium py-[3px] text-[#C93535] border border-solid border-[#C93535] rounded-[4px] px-2">
                            Share AML Invite
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                }
              }
            </cdk-accordion-item>
          </cdk-accordion>
        }
      }
    }
  }
</div>
